import { $data } from '@/setting/data'
import { getFormList, submitForm } from '@/api/form'
// 表单列表
export function getFormListCommon(_this) {
    let params = {
        tenantId: $data.tenantId,
        customFormId: $data.customFormId,
        globalUserId: _this.$cookies.get('globalUserId'),
        linkId: $data.linkId
    }
    return getFormList(params).then(res => {
        return res.content.items;
    })
}
export function submitFormCommon(_this, data) {
    let params = {
        tenantId: $data.tenantId,
        customFormId: $data.customFormId,
        globalUserId: _this.$cookies.get('globalUserId'),
        linkId: $data.linkId,
        instanceId: $data.instanceId,
        items: data,
        openId: $data.openId,
        referenceUrl: window.location.href, 
        signPointItems: [],
        url: window.location.href,
        ver: "v2.0.1"
    }
    return submitForm(params).then(res => {
        console.log(res, '提交成功');
        _this.$message({
            message: 'Has been successfully submitted',
            type: 'success'
        });
        _this.$cookies.set('formSubmitted', true, '7d');
        return true;
    }).catch(err => {
        console.log(err, '提交失败');
        _this.$message({
            message: 'Submission failed. Please resubmit',
            type:'warning'
        });
        return false;
    })
}

// 保存用户表单信息到cookie
export function saveUserFormInfo(_this, info) {
    let userInfo = {
        Fname: info.Fname,
        Lname: info.Lname,
        compName: info.compName,
        title: info.title,
        companyEmail: info.companyEmail,
        mobile: info.mobile,
        product: info.product
    };
    _this.$cookies.set('userFormInfo', userInfo, '7d');
}

// 获取用户表单信息
export function getUserFormInfo(_this) {
    return _this.$cookies.get('userFormInfo');
}